module.exports = __webpack_public_path__ + "img/loan_img_4.c23ff544.png";